export default {
    namespaced: true,
    state: {
        keys: [],
    },
    getters: {
        KEYS: state => {
            return state.keys;
        },
    },
    mutations: {
        KEYS: (state, payload) => {
            return state.keys = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/suppliers/keys',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.keys = responseData.keys
                    payload.th.prepareValue()
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/suppliers/keys',
                parameter: state.keys,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.keys = responseData.keys
                    payload.th.prepareValue()
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                }
            });
        },
    }
}